var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("a", {
      staticClass: "reset-tab",
      attrs: { id: "reset-tab", tabindex: "-1" }
    }),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "skip-link",
        attrs: {
          id: "skip-link",
          href: "#main-content",
          role: "link",
          tabindex: "0"
        },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.scrollToElement("#main-content")
          },
          keyup: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.scrollToElement("#main-content")
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar"
                ])
              ) {
                return null
              }
              return _vm.scrollToElement("#main-content")
            }
          ]
        }
      },
      [
        _vm._v(
          "\n\t\t" +
            _vm._s(_vm.$t("MAIN_CONTENT.Accessibility.skipToMainContent")) +
            "\n\t"
        )
      ]
    ),
    _vm._v(" "),
    _vm.$store.getters.appIsReady
      ? _c(
          "div",
          [
            !_vm.isTestBuilder
              ? _c("header-bar", {
                  key: _vm.role + "_header",
                  attrs: {
                    suiteModule: _vm.suiteModule,
                    title: _vm.headerTitle
                  },
                  on: { updateLocales: _vm.updateLocales }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showSidePanel && _vm.screenLoaded
              ? _c("side-panel", { key: _vm.role + "_sidepanel" })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "main",
              {
                class: _vm.wrapperClass,
                attrs: { id: "main-content", tabindex: "-1" }
              },
              [
                this.studentIsSelected
                  ? _c("webstores-modal", {
                      key: _vm.role + "_webstores_modal"
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    style: !_vm.isTestBuilder
                      ? "padding: 80px 15px 150px 15px;"
                      : ""
                  },
                  [
                    _vm.$store.state.useHeader
                      ? _c(
                          "h1",
                          [
                            !!_vm.$store.state.titleIcon
                              ? _c("font-awesome-icon", {
                                  attrs: { icon: _vm.$store.state.titleIcon }
                                })
                              : _vm._e(),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t(_vm.$store.state.title)) +
                                "\n\t\t\t\t"
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isParentHome &&
                    !_vm.studentIsSelected &&
                    !_vm.isInSettings &&
                    _vm.students.length > 0
                      ? _c("section", [
                          _c("div", { staticClass: "alert alert-danger" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod"
                                  )
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.state.showError
                      ? _c(
                          "div",
                          {
                            staticClass: "alert alert-danger",
                            attrs: { role: "alert" }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "exclamation-triangle" }
                            }),
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("MAIN_CONTENT.App.genericErrorMessage")
                                ) +
                                "\n\t\t\t\t"
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.role === "none"
                      ? _c(
                          "div",
                          {
                            staticClass: "alert alert-danger",
                            attrs: { role: "alert" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.App.permissionDeniedMessage"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isParentHome ||
                    _vm.studentIsSelected ||
                    _vm.isInSettings
                      ? _c("router-view", {
                          key: _vm.$route.fullPath + _vm.role
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("global")
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }